import LinkExternal from '../LinkExternal';
import LinkInternal from '../LinkInternal';
import Item from '../Item';

export default [
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'dialectPanel',
				text: 'Popis nárečového členenia SR',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkExternal({
				href: 'https://korpus.sk/korpus-nareci-slovenskeho-narodneho-korpusu/',
				text: 'Korpus nárečí SNK',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkExternal({
				href: 'https://korpus.sk/korpusy-a-databazy/databazy/archiv-nareci/',
				text: 'Archív nárečí SNK',
			}),
		},
	},
];
